import React, { FC, memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useHistory, useLocation } from "react-router-dom";
import cn from "clsx";
import { useAppSelector } from "@/redux/store";
import { selectProductDetails } from "@/routes/pdp/selectors";
import { handleGoBack } from "@/util/common";
import { selectCommonSettings } from "@/util/selectors";
import { SuccessAddedToCartMessageProps } from "./types";
import { useLanguage, useRouteSlug } from "@/hooks";
import "./style.scss";

const SuccessAddedToCartMessage: FC<SuccessAddedToCartMessageProps> = ({
  isSuccessBlockOpen,
  selectedQty,
  closeSuccessAddedToCartBlock,
  sameSizeInCartCount
}) => {
  const { t } = useTranslation("productDetails");
  const history = useHistory();
  const location = useLocation();
  const item = useAppSelector(selectProductDetails);
  const routeSlug = useRouteSlug();
  const language = useLanguage();
  const commonSettings = useAppSelector(selectCommonSettings);

  const cartAdditionSuccessMessage = (
    <Trans i18nKey="youAlreadyHaveThisProductInCart" ns="productDetails">
      {/* @ts-ignore */}
      "You already have <span>{{ sameSizeInCartCount }}</span> qty of this item
      {/* @ts-ignore */}
      in your cart, now added <span>{{ selectedQty }}</span> more qty!"
    </Trans>
  );

  const addedToCartMessage =
    sameSizeInCartCount && sameSizeInCartCount > 0
      ? cartAdditionSuccessMessage
      : t("addedToCart");

  const brand = item.brand?.label;
  const title = item.title?.label;

  return (
    <div
      className={cn("slideTop fullHeight added_to_cart_wrapper", {
        slideUp: isSuccessBlockOpen,
        slideBack: !isSuccessBlockOpen
      })}
    >
      <div onClick={closeSuccessAddedToCartBlock} className="backOverlay" />
      <div className="added_to_cart_popup">
        <div className="product_name">
          <p>
            {brand && brand}
            {title && <span>{title}</span>}
          </p>
        </div>
        <div className="product_price">
          <p>
            <span className="item_added">{addedToCartMessage}</span>
          </p>
          <p className="item_price">
            {`${item.price?.currency} ${item.price?.current}`}
          </p>
        </div>
        <div className="buttons_wrapper">
          <button
            id="continue_btn"
            onClick={e => {
              closeSuccessAddedToCartBlock(e);
              handleGoBack(location, history, language, commonSettings);
            }}
          >
            {t("continueShopping")}
          </button>
          <Link
            id="view_cart_btn"
            onClick={closeSuccessAddedToCartBlock}
            to={`/${routeSlug}/my-cart/`}
          >
            {t("viewCart")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default memo(SuccessAddedToCartMessage);
